import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Text } from 'foundations-components/components/Text';
import { isFutureContractLineItem, isFutureStartDateCheckoutLineItem, isRelativeStartDateCheckoutLineItem } from '../../types/utils/typeguards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FixedFutureStartDate = ({
  lineItem
}) => /*#__PURE__*/_jsx(FormattedJSXMessage, {
  message: "payments.futureCharges.firstPaymentDate_jsx",
  options: {
    value: lineItem.recurringBillingTerms.initialPayment.futureStartDate,
    format: 'L',
    type: 'utc'
  },
  elements: {
    FormattedDateTime
  }
});
const RelativeFutureStartDate = ({
  lineItem
}) => {
  const relativeDelay = lineItem.recurringBillingTerms.initialPayment.relativeDelay;
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `payments.futureCharges.relativeFirstPayment${relativeDelay.delayUnit}`,
    options: {
      delayLength: relativeDelay.delayLength,
      count: relativeDelay.delayLength
    }
  });
};
const FixedFutureContractStartDate = ({
  lineItem
}) => {
  var _lineItem$recurringBi;
  const futureStartDate = lineItem.futureStartDate;
  if (futureStartDate) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "payments.futureCharges.nextPaymentDate_jsx",
      options: {
        value: futureStartDate,
        format: 'L',
        type: 'utc'
      },
      elements: {
        FormattedDateTime
      }
    });
  }
  const initialPaymentFutureStartDate = (_lineItem$recurringBi = lineItem.recurringBillingTerms) === null || _lineItem$recurringBi === void 0 ? void 0 : _lineItem$recurringBi.initialPayment.futureStartDate;
  if (initialPaymentFutureStartDate) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "payments.futureCharges.nextPaymentDate_jsx",
      options: {
        value: initialPaymentFutureStartDate,
        format: 'L',
        type: 'utc'
      },
      elements: {
        FormattedDateTime
      }
    });
  }
  return null;
};
const FirstPaymentDateSubtext = ({
  lineItem
}) => {
  const hasFutureStartDate = isFutureStartDateCheckoutLineItem(lineItem);
  const hasRelativeStartDate = isRelativeStartDateCheckoutLineItem(lineItem);
  const hasFutureContractDate = isFutureContractLineItem(lineItem);
  if (!hasFutureStartDate && !hasRelativeStartDate && !hasFutureContractDate) {
    throw new Error('Unknown initialPayment type');
  }
  return /*#__PURE__*/_jsxs(Text, {
    as: "small",
    color: "text-core-subtle",
    children: [hasFutureStartDate && /*#__PURE__*/_jsx(FixedFutureStartDate, {
      lineItem: lineItem
    }), hasRelativeStartDate && /*#__PURE__*/_jsx(RelativeFutureStartDate, {
      lineItem: lineItem
    }), hasFutureContractDate && /*#__PURE__*/_jsx(FixedFutureContractStartDate, {
      lineItem: lineItem
    })]
  });
};
export default FirstPaymentDateSubtext;